import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 使用 Element 默认尺寸（字体不缩小）
Vue.use(Element)

// 可选：只保留 zIndex 配置
Vue.prototype.$ELEMENT = {
  zIndex: 3000
}
